import React from 'react';
import { Link } from 'react-router-dom';

const Dashboard = () => {
  return (
    <div className="page-body">
      <div className="container-xl">
        <div className="row g-3">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <h2 className="card-title mb-2">Coin Dashboard</h2>
                <p className="text-muted mb-0">
                  Minimal admin UI wired to the coin APIs.
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-4">
            <Link to="/coins" className="card card-link">
              <div className="card-body">
                <div className="fw-bold">Coins</div>
                <div className="text-muted">Browse/search coin catalog</div>
              </div>
            </Link>
          </div>
          <div className="col-12 col-md-4">
            <Link to="/my-coins" className="card card-link">
              <div className="card-body">
                <div className="fw-bold">My Coins</div>
                <div className="text-muted">View authenticated coin list</div>
              </div>
            </Link>
          </div>
          <div className="col-12 col-md-4">
            <Link to="/coin-config" className="card card-link">
              <div className="card-body">
                <div className="fw-bold">Coin Config</div>
                <div className="text-muted">Inspect server-side config</div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard; 